export const SEARCH_COLOR_SCHEMES = ['primary', 'secondary'] as const;
export type SearchColorScheme = (typeof SEARCH_COLOR_SCHEMES)[number];
